/* eslint-disable */
import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import m from '@utils/strings';

class BeneficiarioInelegivel extends Component {
    render() {
        let { beneficiario } = this.props;
        let elegibilidade = beneficiario && beneficiario.data && beneficiario.data.Elegibilidade? beneficiario.data.Elegibilidade : null;
        let codigoNegativa = '';
        if(elegibilidade)
            codigoNegativa = elegibilidade.CodigoMotivoNegativa.replace(/([\a-zA-Z])/g,'');
        return (
            <div>
                <div className={"div-area-resultado-autorizacao"} style={{ marginLeft: 50, marginTop: 40 }}>
                    <label id={"label-erro-servico"}>
                        {m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_BENEFICIARIO_NAO_ELEGIVEL}
                    </label>
                </div>
                <div className={"div-separador-top-10"}>
                    <label id={"descricao-erro-procedimento"}>
                        {codigoNegativa} - {elegibilidade? elegibilidade.DescricaoMotivoNegativa : ''}
                    </label>
                </div>
                <div className={"div-separador-top-bottom-25"}>
                    <hr className={"hr-class"} style={{marginLeft: 100, marginRight: 400 }}/>
                </div>
                <div className={"div-separador-top-10"}>
                    {<Button
                        onClick={() => {
                            this.props.resetAllStates();
                        }}
                        className={"btn-default-cemig"}
                        style={{ marginLeft: 100 }}
                        >
                        {m.TELA_EXAMES_PROCEDIMENTOS.LABEL_NOVO_ATENDIMENTO} (ENTER)
                        </Button>}
                </div>
            </div>
        );
    }
}

export default BeneficiarioInelegivel;
